<template><div><h1 id="adresstyp" tabindex="-1"><a class="header-anchor" href="#adresstyp"><span>Adresstyp</span></a></h1>
<p>Adresstyp — Verwaltung von Adresstypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit Adresstypen werden Kontaktinformatonen wie Telefon, Fax, E-Mail gruppiert.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Kommunikation → Adresstypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Adresstyp</dt>
<dd>Code, Kurzbezeichnung.</dd>
<dt>Bezeichnung</dt>
<dd>Freies Textfeld zur Beschreibung des Adressyps</dd>
<dt>Priority</dt>
<dd>Wenn mehrere Einträge mit gleichem Kanal vorhanden sind, kann über diese Priorisierung festgelegt werden, welcher Eintrag prioritär z.B. für Exports verwendet werden soll.</dd>
<dt>Unique</dt>
<dd>Datensätze mit Unicue=&quot;ja&quot; dürfen nicht mehrfach in der Datenbank vorhanden sein. Z.B. wäre es somit nicht mehr möglich, die gleiche E-Mailadresse bei 2 verschiedenen Adressen einzutragen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblkommkanal.html">Kanal</RouteLink></p>
</div></template>


